import firebase from "firebase/app";
import store from "@/store";

export default class UploadAdapter {
  loader;
  facility = store.state.authModule.currentFacility;
  path = `${this.facility}/emailPictures/`;

  constructor( loader ) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then(
      file =>
        new Promise((resolve, reject) => {
          const storage = firebase.storage().ref();
          const uploadTask = storage
            .child(`${this.path}/${file.name}`)
            .put(file);
          uploadTask.on(
            firebase.storage.TaskEvent.STATE_CHANGED,
            function(snapshot) {
              const progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              console.log("Upload is " + progress + "% done");
              document.getElementById("uploadingImageProgress").style.display = "flex";

              switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                  console.log("Upload is paused");
                  break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                  console.log("Upload is running");
                  break;
              }
            },
            function(error: any) {
              switch (error.code) {
                case "storage/unauthorized":
                  reject(" User doesn't have permission to access the object");
                  break;

                case "storage/canceled":
                  reject("User canceled the upload");
                  break;

                case "storage/unknown":
                  reject(
                    "Unknown error occurred, inspect error.serverResponse"
                  );
                  break;
              }
            },
            function() {
              uploadTask.snapshot.ref
                .getDownloadURL()
                .then(function(downloadURL) {
                  resolve({
                    default: downloadURL
                  });
                  document.getElementById("uploadingImageProgress").style.display = "none";
                });
            }
          );
        })
    );
  }
}